import { RbacRole } from './roles'
import type { PermissionEntry } from './permissions'

const GA = RbacRole.GlobalAdmin
const OA = RbacRole.Admin
const MA = RbacRole.MachineAdmin

const action = (name: string, roles: RbacRole[]): PermissionEntry => ({ name, roles }) as const

/**
 * Identity-owned permission entries. The wider `Action` matrix in
 * `domains-axilon-devops/constants` re-exports these and adds devops-resource
 * actions (Applications, Snapshots, Machines, etc.).
 */
export const IdentityAction = {
  Users: {
    Create: action('users.create', [GA, OA]),
    Update: action('users.update', [GA]),
    UpdatePassword: action('users.updatePassword', [GA, OA]),
    Disable: action('users.disable', [GA, OA])
  },
  RoleAssignments: {
    Create: action('roleAssignments.create', [GA, MA]),
    Update: action('roleAssignments.update', [GA, MA]),
    Delete: action('roleAssignments.delete', [GA, MA]),
    DeleteGlobalAdmin: action('roleAssignments.deleteGlobalAdmin', [GA])
  }
} as const
